<div class="maintenance-tab-main" *ngIf="small_screen && retrievingNotes">
  <ion-spinner name="bubbles"></ion-spinner>
  <p>{{ 'MAINTENANCE.RETRIEVING_NOTES' | translate }}</p>
</div>

<div class="maintenance-tab-main small-screen-view" *ngIf="small_screen && !retrievingNotes">
  <div class="small-screen-header">
    <h4>{{ 'MAINTENANCE.TITLE' | translate }}</h4>
    <div class="small-screen-actions" *ngIf="!viewingKilnlinkFreeKilns">
      <ion-button (click)="createNewNote()" color="primary" fill="solid" size="small">
        <ion-icon name="add-outline" slot="start"></ion-icon>
        {{ 'MAINTENANCE.NEW' | translate }}
      </ion-button>
      <ion-button *ngIf="maintenanceNotesEnabled" (click)="requestMaintenance()" color="warning" fill="solid" size="small">
        <ion-icon name="add-outline" slot="start"></ion-icon>
        {{ 'MAINTENANCE.REQUEST_MAINTENANCE' | translate }}
      </ion-button>
    </div>
  </div>

  <!-- Show form when creating/editing -->
  <div class="small-screen-form" *ngIf="(isCreatingNew || isEditing) && !viewingKilnlinkFreeKilns">
    <form [formGroup]="maintenanceNoteForm" (submit)="onSubmit(maintenanceNoteForm.value)">
      <ion-item>
        <ion-label>{{ 'MAINTENANCE.DATE' | translate }}:</ion-label>
        <ion-input slot="end" type="date" formControlName="date" fill="solid" [disabled]="isBasicOrReadonlyUser()"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label>{{ 'MAINTENANCE.TECHNICIAN' | translate }}:</ion-label>
        <ion-input slot="end" type="text" formControlName="technician" fill="solid" [placeholder]="'MAINTENANCE.TECHNICIAN_NAME' | translate"></ion-input>
      </ion-item>

      <ion-item>
        <ion-label>{{ 'MAINTENANCE.TYPE' | translate }}:</ion-label>
        <ion-select slot="end" formControlName="type">
          <ion-select-option *ngFor="let option of getMaintenanceTypes()" [default]="option.value === 'replace_one_element'" value="{{option.value}}">{{option.option_text}}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item>
        <ion-label>{{ 'MAINTENANCE.NOTES' | translate }}:</ion-label>
        <ion-textarea rows="6" cols="50" formControlName="notes" fill="solid" [placeholder]="'MAINTENANCE.ENTER_NOTES_HERE' | translate"></ion-textarea>
      </ion-item>

      <ion-item *ngIf="maintenanceNotesEnabled && canSetStatus()">
        <ion-label>{{ 'MAINTENANCE.STATUS' | translate }}:</ion-label>
        <ion-select slot="end" formControlName="status">
          <ion-select-option *ngFor="let status of maintenance_statuses" [value]="status.value">{{status.option_text}}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item *ngIf="canMarkComplete()">
        <ion-label>{{ 'MAINTENANCE.COMPLETE' | translate }}:</ion-label>
        <ion-toggle slot="end" formControlName="complete"></ion-toggle>
      </ion-item>

      <div class="form-actions">
        <ion-button (click)="cancelForm()" color="medium" fill="outline">
          {{ 'MAINTENANCE.CANCEL' | translate }}
        </ion-button>
        <ion-button type="submit" color="tertiary">
          {{isEditing ? ('MAINTENANCE.EDIT_NOTE' | translate): ('MAINTENANCE.CREATE_NOTE' | translate)}}
        </ion-button>
      </div>
    </form>
  </div>

  <!-- Show note details when a note is selected -->
  <div class="small-screen-details" *ngIf="!isCreatingNew && !isEditing && selectedNote && !viewingKilnlinkFreeKilns">
    <div class="note-details">
      <div class="detail-item">
        <label>{{ 'MAINTENANCE.DATE' | translate }}:</label>
        <span>{{selectedNote.note_date | date:'mediumDate':'+0000' }}</span>
      </div>
      <div class="detail-item" *ngIf="selectedNote.firing_number != null && selectedNote.firing_number !== ''">
        <label>{{ 'MAINTENANCE.FIRING_NUMBER' | translate }}:</label>
        <span>{{ selectedNote.firing_number }}</span>
      </div>
      <div class="detail-item">
        <label>{{ 'MAINTENANCE.TECHNICIAN' | translate }}:</label>
        <span>{{selectedNote.technician}}</span>
      </div>
      <div class="detail-item">
        <label>{{ 'MAINTENANCE.TYPE' | translate }}:</label>
        <span>{{ getFriendlyType(selectedNote.type) }}</span>
      </div>
      <div class="detail-item">
        <label>{{ 'MAINTENANCE.NOTES' | translate }}:</label>
        <span class="note-text">{{selectedNote.notes}}</span>
      </div>
      <div class="detail-item" *ngIf="maintenanceNotesEnabled">
        <label>{{ 'MAINTENANCE.STATUS' | translate }}:</label>
        <span><ion-badge [color]="getStatusColor(selectedNote.status)">{{ getFriendlyStatus(selectedNote.status) }}</ion-badge></span>
      </div>
      <div class="detail-actions" *ngIf="canEditNotes()">
        <ion-button (click)="editNote(selectedNote)" color="warning" fill="outline">
          <ion-icon name="create-outline" slot="start"></ion-icon>
          {{ 'MAINTENANCE.EDIT' | translate }}
        </ion-button>
        <ion-button (click)="deleteNote(selectedNote)" color="danger" fill="outline">
          <ion-icon name="trash-outline" slot="start"></ion-icon>
          {{ 'MAINTENANCE.DELETE' | translate }}
        </ion-button>
      </div>
    </div>
  </div>

  <!-- Show list of notes when not creating/editing/viewing details -->
  <div class="small-screen-list" *ngIf="!isCreatingNew && !isEditing && !selectedNote && !viewingKilnlinkFreeKilns">
    <div class="notes-list" *ngIf="maintenance_notes && maintenance_notes.length > 0">
      <div class="note-item" 
           *ngFor="let note of maintenance_notes" 
           (click)="selectNote(note)">
        <div class="note-header">
          <span class="note-date">{{note.note_date | date:'mediumDate':'+0000' }}</span>
          <span class="note-firing-number" *ngIf="note.firing_number != null && note.firing_number !== ''">{{ 'MAINTENANCE.FIRING_NUMBER' | translate }}: {{ note.firing_number }}</span>
          <span class="note-technician">{{note.technician}}</span>
        </div>
        <div class="note-content">
          <span class="note-type">{{ getFriendlyType(note.type) }}</span>
          <span class="note-status" *ngIf="maintenanceNotesEnabled">
            <ion-badge [color]="getStatusColor(note.status)">{{ getFriendlyStatus(note.status) }}</ion-badge>
          </span>
        </div>
        <div class="note-preview">{{note.notes | slice:0:100}}{{note.notes.length > 100 ? '...' : ''}}</div>
      </div>
    </div>
    
    <div class="no-notes" *ngIf="maintenance_notes && maintenance_notes.length === 0">
      <ion-icon name="document-outline" size="large"></ion-icon>
      <p>{{ 'MAINTENANCE.NO_MAINTENANCE_NOTES' | translate }}</p>
    </div>
  </div>

  <!-- Show message for KilnLink Free kilns -->
  <div class="no-notes" *ngIf="viewingKilnlinkFreeKilns">
    <ion-icon name="information-circle-outline" size="large"></ion-icon>
    <p>{{ 'MAINTENANCE.KILNLINK_FREE_MAINTENANCE_MESSAGE' | translate }}</p>
  </div>
</div>

<div class="maintenance-tab-main" *ngIf="!small_screen">
  <div class="maintenance-container">
    <!-- Left side: List of notes -->
    <div class="maintenance-list-section">
      <div class="list-header">
        <h4>{{ 'MAINTENANCE.TITLE' | translate }}</h4>
        <div class="list-actions" *ngIf="!viewingKilnlinkFreeKilns">
          <ion-button (click)="createNewNote()" color="white" fill="solid" size="small">
            <ion-icon name="add-outline" slot="start"></ion-icon>
            {{ 'MAINTENANCE.NEW' | translate }}
          </ion-button>
          <ion-button *ngIf="maintenanceNotesEnabled" (click)="requestMaintenance()" color="warning" fill="solid" size="small">
            <ion-icon name="add-outline" slot="start"></ion-icon>
            {{ 'MAINTENANCE.REQUEST_MAINTENANCE' | translate }}
          </ion-button>
        </div>
      </div>
      
      <div class="notes-list" *ngIf="!viewingKilnlinkFreeKilns && maintenance_notes && maintenance_notes.length > 0">
        <div class="note-item" 
             *ngFor="let note of maintenance_notes" 
             [class.selected]="selectedNote && selectedNote.id === note.id"
             (click)="selectNote(note)">
          <div class="note-header">
            <span class="note-date">{{note.note_date | date:'mediumDate':'+0000' }}</span>
            <span class="note-firing-number" *ngIf="note.firing_number != null && note.firing_number !== ''">{{ 'MAINTENANCE.FIRING_NUMBER' | translate }}: {{ note.firing_number }}</span>
            <span class="note-technician">{{note.technician}}</span>
          </div>
          <div class="note-content">
            <span class="note-type">{{ getFriendlyType(note.type) }}</span>
            <span class="note-status" *ngIf="maintenanceNotesEnabled">
              <ion-badge [color]="getStatusColor(note.status)">{{ getFriendlyStatus(note.status) }}</ion-badge>
            </span>
          </div>
          <div class="note-preview">{{note.notes | slice:0:100}}{{note.notes.length > 100 ? '...' : ''}}</div>
        </div>
      </div>
      
      <div class="no-notes" *ngIf="!viewingKilnlinkFreeKilns && maintenance_notes && maintenance_notes.length === 0">
        <p>{{ 'MAINTENANCE.NO_MAINTENANCE_NOTES' | translate }}</p>
      </div>
      
      <div class="no-notes" *ngIf="viewingKilnlinkFreeKilns">
        <p>{{ 'MAINTENANCE.KILNLINK_FREE_MAINTENANCE_MESSAGE' | translate }}</p>
      </div>
    </div>

    <!-- Right side: Note details/form -->
    <div class="maintenance-details-section" *ngIf="!viewingKilnlinkFreeKilns">
      <div class="details-header">
        <h4 *ngIf="!isCreatingNew && selectedNote">{{ 'MAINTENANCE.MAINTENANCE_LOG_RECORD' | translate }}</h4>
        <h4 *ngIf="isCreatingNew">{{ 'MAINTENANCE.CREATE_NEW_NOTE' | translate }}</h4>
        <h4 *ngIf="!isCreatingNew && !selectedNote">{{ 'MAINTENANCE.SELECT_NOTE' | translate }}</h4>
      </div>
      
      <!-- Note details view -->
      <div class="note-details" *ngIf="!isCreatingNew && selectedNote && !isEditing">
        <div class="detail-item">
          <label>{{ 'MAINTENANCE.DATE' | translate }}:</label>
          <span>{{selectedNote.note_date | date:'mediumDate':'+0000' }}</span>
        </div>
        <div class="detail-item" *ngIf="selectedNote.firing_number != null && selectedNote.firing_number !== ''">
          <label>{{ 'MAINTENANCE.FIRING_NUMBER' | translate }}:</label>
          <span>{{ selectedNote.firing_number }}</span>
        </div>
        <div class="detail-item">
          <label>{{ 'MAINTENANCE.TECHNICIAN' | translate }}:</label>
          <span>{{selectedNote.technician}}</span>
        </div>
        <div class="detail-item">
          <label>{{ 'MAINTENANCE.TYPE' | translate }}:</label>
          <span>{{ getFriendlyType(selectedNote.type) }}</span>
        </div>
        <div class="detail-item">
          <label>{{ 'MAINTENANCE.NOTES' | translate }}:</label>
          <span class="note-text">{{selectedNote.notes}}</span>
        </div>
        <div class="detail-item" *ngIf="maintenanceNotesEnabled">
          <label>{{ 'MAINTENANCE.STATUS' | translate }}:</label>
          <span><ion-badge [color]="getStatusColor(selectedNote.status)">{{ getFriendlyStatus(selectedNote.status) }}</ion-badge></span>
        </div>
        <div class="detail-actions" *ngIf="canEditNotes()">
          <ion-button (click)="editNote(selectedNote)" color="warning" fill="outline">
            <ion-icon name="create-outline" slot="start"></ion-icon>
            {{ 'MAINTENANCE.EDIT' | translate }}
          </ion-button>
          <ion-button (click)="deleteNote(selectedNote)" color="danger" fill="outline">
            <ion-icon name="trash-outline" slot="start"></ion-icon>
            {{ 'MAINTENANCE.DELETE' | translate }}
          </ion-button>
        </div>
      </div>

      <!-- Form for create/edit -->
      <div class="note-form" *ngIf="isCreatingNew || isEditing">
        <form [formGroup]="maintenanceNoteForm" (submit)="onSubmit(maintenanceNoteForm.value)">
          <ion-item>
            <ion-label>{{ 'MAINTENANCE.DATE' | translate }}:</ion-label>
            <ion-input slot="end" type="date" formControlName="date" fill="solid" [disabled]="isBasicOrReadonlyUser()"></ion-input>
          </ion-item>

          <ion-item>
            <ion-label>{{ 'MAINTENANCE.TECHNICIAN' | translate }}:</ion-label>
            <ion-input slot="end" type="text" formControlName="technician" fill="solid" [placeholder]="'MAINTENANCE.TECHNICIAN_NAME' | translate"></ion-input>
          </ion-item>

          <ion-item>
            <ion-label>{{ 'MAINTENANCE.TYPE' | translate }}:</ion-label>
            <ion-select slot="end" formControlName="type">
              <ion-select-option *ngFor="let option of getMaintenanceTypes()" [default]="option.value === 'replace_one_element'" value="{{option.value}}">{{option.option_text}}</ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item>
            <ion-label>{{ 'MAINTENANCE.NOTES' | translate }}:</ion-label>
            <ion-textarea rows="6" cols="50" formControlName="notes" fill="solid" [placeholder]="'MAINTENANCE.ENTER_NOTES_HERE' | translate"></ion-textarea>
          </ion-item>

          <ion-item *ngIf="maintenanceNotesEnabled && canSetStatus()">
            <ion-label>{{ 'MAINTENANCE.STATUS' | translate }}:</ion-label>
            <ion-select slot="end" formControlName="status">
              <ion-select-option *ngFor="let status of maintenance_statuses" [value]="status.value">{{status.option_text}}</ion-select-option>
            </ion-select>
          </ion-item>

          <ion-item *ngIf="canMarkComplete()">
            <ion-label>{{ 'MAINTENANCE.COMPLETE' | translate }}:</ion-label>
            <ion-toggle slot="end" formControlName="complete"></ion-toggle>
          </ion-item>

          <div class="form-actions">
            <ion-button (click)="cancelForm()" color="medium" fill="outline">
              {{ 'MAINTENANCE.CANCEL' | translate }}
            </ion-button>
            <ion-button type="submit" color="tertiary">
              {{isEditing ? ('MAINTENANCE.EDIT_NOTE' | translate): ('MAINTENANCE.CREATE_NOTE' | translate)}}
            </ion-button>
          </div>
        </form>
      </div>

      <!-- Empty state -->
      <div class="empty-state" *ngIf="!isCreatingNew && !selectedNote && !isEditing">
        <ion-icon name="document-outline" size="large"></ion-icon>
        <p>{{ 'MAINTENANCE.SELECT_NOTE_TO_VIEW' | translate }}</p>
      </div>
    </div>
  </div>
</div>